import baseChart from './customBaseChart'


export default (opt = {}) => {

  const colorList = opt.colorList || [];
  const data = opt.data || {};

  let xAxis = {
    type: 'category',
    data: data.timeRang || []
  };
  let yAxis = {
    type: 'value',
    data: []
  };

  if (data.axis !== 'horizontal') {
    xAxis = {
      type: 'value',
      data: []
    };
    yAxis = {
      type: 'category',
      data: data.timeRang || []
    };
  }

  return Object.assign(baseChart(opt), {
    xAxis,
    yAxis,
  
    series: colorList.map((item) => {
      return {
        stack: 'bar',
        name: item.name,
        barGap: 0,
        data: data[item.value] || [],
        type: 'bar',
        itemStyle: {
          normal: {
            color: item.color || ''
          }
        }
      }
    }),
    
    animationEasing: 'elasticOut',
    animationDelayUpdate: function (idx) {
      return idx * 5;
    }
  })
}


// WEBPACK FOOTER //
// src/chart/wordOfMouthContrast.js